<template>
  <div class="outerBlock">
  <div class="container-fluid mission">
      <h1>{{t('Enjoy  youself while contributing to nature conservation')}}</h1>
      <div>
        <h4>{{t('Our mission is to bring you on an adventure in a sustainable relationship with nature')}}</h4>
        <p>{{t('We promote good environmental practices with the comunity')}}</p>
        <p>{{t('1% of our profits will be donated to nature conservancy projects')}}</p>
        <div class="actions text-xs-center">
          <router-link class="btn btn-primary btn-lg" :to="`/${language}/about-us`">{{t('Find out more')}}</router-link>
        </div>
      </div>
  </div>
</div>
</template>


<script>
import { mapState } from 'vuex';

export default {
  name: 'Mission',
  computed: {
    ...mapState({
      language: state => state.language,
    }),
  },
};

</script>


<style lang="scss" scoped>
.mission {
  text-align: center;
  min-height: 60vh;
  background: white;
  margin-left: 0;
  margin-right: 0;
  font-size: 18px;
  overflow: hidden;
  background: url('/static/img/geres-cat-cris-ola.jpg') no-repeat;
  background-attachment: fixed;
  background-size: cover;
  color: white;
  text-shadow: 2px 2px 5px rgba(0, 0, 0, 1);
  min-height: calc(100vh - 200px);
  margin-bottom: -150px;
}

h1 {
  padding-top: 10vh;
  margin-bottom: 50px;
}
h4 {
  max-width: 30em;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 50px;
  line-height: 1.5;
}
.outerBlock {
}
.actions {
  margin-top: 70px;
  margin-bottom: 200px;
}
</style>



// WEBPACK FOOTER //
// Mission.vue?29ac2bd0